import type { Expediente } from '../types'
import { fechaRel } from '../utils/fechas'

export const EXPEDIENTES: Expediente[] = [
  {
    id: 'ex-01',
    localizador: 'VER-PEN-2026-0042',
    cliente: 'Comercializadora del Golfo, S.A. de C.V.',
    clienteContacto: 'Ing. Alfonso Rentería · 229 145 8890',
    materia: 'Penal',
    tipoAsunto: 'Fraude',
    autoridad: 'Fiscalía Regional Zona Centro, Veracruz',
    numeroJudicial: 'FRZC/VER/1189/2026',
    sucursalId: 'ver',
    abogadoIds: ['ab-01', 'ab-02'],
    ubicacion: { almacen: 'Almacén A', pasillo: 'Pasillo 1', estante: 'Estante B', caja: 'Caja 04' },
    estado: 'Activo',
    fechaApertura: fechaRel(-212),
    etapaActual: 2,
    cuantia: '$4,850,000.00 MXN',
    resumen:
      'Denuncia por fraude genérico en contra de dos ex proveedores por facturación simulada durante el ejercicio 2024.',
    prestadoA: 'Lic. Mariana Cervantes Rojo',
    prestadoDesde: fechaRel(-9),
  },
  {
    id: 'ex-02',
    localizador: 'VER-CIV-2026-0117',
    cliente: 'Rosa María Betancourt Islas',
    clienteContacto: 'rm.betancourt@correo.mx · 229 880 2214',
    materia: 'Civil',
    tipoAsunto: 'Reivindicatorio',
    autoridad: 'Juzgado 1° Civil de Primera Instancia, Veracruz',
    numeroJudicial: '452/2026-I',
    sucursalId: 'ver',
    abogadoIds: ['ab-02'],
    ubicacion: { almacen: 'Almacén A', pasillo: 'Pasillo 1', estante: 'Estante B', caja: 'Caja 04' },
    estado: 'Activo',
    fechaApertura: fechaRel(-160),
    etapaActual: 3,
    cuantia: '$1,240,000.00 MXN',
    resumen:
      'Acción reivindicatoria respecto de un predio urbano en Boca del Río con posesión de tercero de mala fe.',
  },
  {
    id: 'ex-03',
    localizador: 'VER-LAB-2026-0088',
    cliente: 'Astilleros Peninsulares, S. de R.L.',
    clienteContacto: 'Lic. Norma Gaytán · 229 700 1123',
    materia: 'Laboral',
    tipoAsunto: 'Despido injustificado',
    autoridad: 'Centro de Conciliación Laboral de Jalisco',
    numeroJudicial: 'CCL/VER/0771/2026',
    sucursalId: 'ver',
    abogadoIds: ['ab-09'],
    ubicacion: { almacen: 'Almacén A', pasillo: 'Pasillo 2', estante: 'Estante A', caja: 'Caja 09' },
    estado: 'Activo',
    fechaApertura: fechaRel(-75),
    etapaActual: 1,
    resumen:
      'Defensa patronal por demanda de reinstalación y pago de salarios caídos de tres trabajadores del área de soldadura.',
  },
  {
    id: 'ex-04',
    localizador: 'VER-AMP-2025-0301',
    cliente: 'Transportes Bravo Hermanos',
    clienteContacto: 'Sr. Julián Bravo · 229 552 6640',
    materia: 'Amparo',
    tipoAsunto: 'Amparo indirecto',
    autoridad: 'Juzgado 3° de Distrito en Veracruz',
    numeroJudicial: '1544/2025',
    sucursalId: 'ver',
    abogadoIds: ['ab-01'],
    ubicacion: { almacen: 'Almacén A', pasillo: 'Pasillo 2', estante: 'Estante C', caja: 'Caja 12' },
    estado: 'Activo',
    fechaApertura: fechaRel(-320),
    etapaActual: 4,
    resumen:
      'Amparo contra el aseguramiento de seis unidades de carga ordenado por la autoridad fiscal estatal.',
  },
  {
    id: 'ex-05',
    localizador: 'CMX-MER-2026-0009',
    cliente: 'Grupo Inmobiliario Altavista, S.A.P.I.',
    clienteContacto: 'Lic. Paola Serrano · 55 6612 0088',
    materia: 'Mercantil',
    tipoAsunto: 'Juicio ejecutivo mercantil',
    autoridad: 'Juzgado 14° Civil de la CDMX',
    numeroJudicial: '109/2026',
    sucursalId: 'cmx',
    abogadoIds: ['ab-04', 'ab-03'],
    ubicacion: { almacen: 'Almacén Central', pasillo: 'Pasillo 1', estante: 'Estante A', caja: 'Caja 02' },
    estado: 'Activo',
    fechaApertura: fechaRel(-98),
    etapaActual: 2,
    cuantia: '$12,600,000.00 MXN',
    resumen:
      'Cobro de dos pagarés vencidos suscritos por una desarrolladora, con embargo sobre bienes inmuebles.',
    prestadoA: 'Sr. Braulio Camacho (Archivo CMX)',
    prestadoDesde: fechaRel(-2),
  },
  {
    id: 'ex-06',
    localizador: 'CMX-ADM-2026-0031',
    cliente: 'Farmacéutica Reyver, S.A. de C.V.',
    clienteContacto: 'C.P. Aurelio Nájera · 55 8890 4417',
    materia: 'Administrativo',
    tipoAsunto: 'Devolución de impuestos',
    autoridad: 'Tribunal Federal de Justicia Administrativa, Sala Metropolitana',
    numeroJudicial: '4412/26-17-05-3',
    sucursalId: 'cmx',
    abogadoIds: ['ab-03'],
    ubicacion: { almacen: 'Almacén Central', pasillo: 'Pasillo 1', estante: 'Estante B', caja: 'Caja 05' },
    estado: 'Activo',
    fechaApertura: fechaRel(-140),
    etapaActual: 2,
    cuantia: '$3,105,400.00 MXN',
    resumen:
      'Juicio de nulidad por la negativa ficta de devolución de saldo a favor de IVA del ejercicio 2024.',
  },
  {
    id: 'ex-07',
    localizador: 'CMX-CIV-2025-0244',
    cliente: 'Eduardo Villaseñor Mendiola',
    clienteContacto: 'e.villasenor@correo.mx · 55 2201 7745',
    materia: 'Civil',
    tipoAsunto: 'Arrendamiento',
    autoridad: 'Juzgado 14° Civil de la CDMX',
    numeroJudicial: '883/2025',
    sucursalId: 'cmx',
    abogadoIds: ['ab-04'],
    ubicacion: { almacen: 'Almacén Central', pasillo: 'Pasillo 2', estante: 'Estante A', caja: 'Caja 07' },
    estado: 'Concluido',
    fechaApertura: fechaRel(-410),
    etapaActual: 6,
    resumen:
      'Rescisión de contrato de arrendamiento y desocupación de local comercial en la colonia Roma.',
  },
  {
    id: 'ex-08',
    localizador: 'CMX-AMP-2026-0058',
    cliente: 'Asociación de Colonos Lomas Verdes A.C.',
    clienteContacto: 'Arq. Beatriz Loera · 55 4470 1102',
    materia: 'Amparo',
    tipoAsunto: 'Amparo contra leyes',
    autoridad: 'Juzgado 3° de Distrito en Veracruz',
    numeroJudicial: '612/2026',
    sucursalId: 'cmx',
    abogadoIds: ['ab-03'],
    ubicacion: { almacen: 'Almacén Central', pasillo: 'Pasillo 2', estante: 'Estante C', caja: 'Caja 11' },
    estado: 'Activo',
    fechaApertura: fechaRel(-46),
    etapaActual: 2,
    resumen:
      'Amparo contra el reglamento municipal de uso de suelo que autoriza densidad habitacional adicional.',
  },
  {
    id: 'ex-09',
    localizador: 'GDL-FAM-2026-0073',
    cliente: 'Claudia Irene Pizarro Ávalos',
    clienteContacto: 'c.pizarro@correo.mx · 33 1188 5520',
    materia: 'Familiar',
    tipoAsunto: 'Guarda y custodia',
    autoridad: 'Juzgado 5° Familiar de Guadalajara',
    numeroJudicial: '1290/2026',
    sucursalId: 'gdl',
    abogadoIds: ['ab-05'],
    ubicacion: { almacen: 'Almacén Poniente', pasillo: 'Pasillo 1', estante: 'Estante A', caja: 'Caja 03' },
    estado: 'Activo',
    fechaApertura: fechaRel(-62),
    etapaActual: 2,
    resumen:
      'Solicitud de guarda y custodia definitiva de dos menores, con régimen de convivencias supervisadas.',
  },
  {
    id: 'ex-10',
    localizador: 'GDL-LAB-2026-0121',
    cliente: 'Manufacturas Tlaquepaque, S.A.',
    clienteContacto: 'Lic. Sergio Ibarra · 33 3390 4412',
    materia: 'Laboral',
    tipoAsunto: 'Prestaciones devengadas',
    autoridad: 'Centro de Conciliación Laboral de Jalisco',
    numeroJudicial: 'CCL/JAL/2210/2026',
    sucursalId: 'gdl',
    abogadoIds: ['ab-05'],
    ubicacion: { almacen: 'Almacén Poniente', pasillo: 'Pasillo 1', estante: 'Estante B', caja: 'Caja 06' },
    estado: 'Activo',
    fechaApertura: fechaRel(-30),
    etapaActual: 3,
    resumen:
      'Reclamo de prima de antigüedad, vacaciones y aguinaldo de doce ex trabajadores de línea de producción.',
  },
  {
    id: 'ex-11',
    localizador: 'GDL-PEN-2026-0014',
    cliente: 'Óscar Daniel Zepeda Márquez',
    clienteContacto: 'Fam. Zepeda · 33 2077 9931',
    materia: 'Penal',
    tipoAsunto: 'Robo agravado',
    autoridad: 'Juzgado de Control del Sistema Penal Acusatorio, Monterrey',
    numeroJudicial: 'JC/GDL/331/2026',
    sucursalId: 'gdl',
    abogadoIds: ['ab-06'],
    ubicacion: { almacen: 'Almacén Poniente', pasillo: 'Pasillo 2', estante: 'Estante A', caja: 'Caja 08' },
    estado: 'Activo',
    fechaApertura: fechaRel(-51),
    etapaActual: 3,
    resumen:
      'Defensa particular en etapa de investigación complementaria con medida cautelar de firma periódica.',
    prestadoA: 'Srita. Miriam Aceves (Recepción GDL)',
    prestadoDesde: fechaRel(-16),
  },
  {
    id: 'ex-12',
    localizador: 'GDL-MER-2025-0198',
    cliente: 'Distribuidora Agrícola El Bajío',
    clienteContacto: 'Sr. Rubén Anguiano · 33 1560 7788',
    materia: 'Mercantil',
    tipoAsunto: 'Incumplimiento de contrato',
    autoridad: 'Tribunal Superior de Justicia de N.L., Sala Civil',
    numeroJudicial: '714/2025',
    sucursalId: 'gdl',
    abogadoIds: ['ab-06', 'ab-05'],
    ubicacion: { almacen: 'Almacén Poniente', pasillo: 'Pasillo 3', estante: 'Estante D', caja: 'Caja 15' },
    estado: 'Archivado',
    fechaApertura: fechaRel(-505),
    etapaActual: 5,
    resumen:
      'Incumplimiento de contrato de suministro de fertilizantes; sentencia favorable y archivo por cumplimiento.',
  },
  {
    id: 'ex-13',
    localizador: 'MTY-CIV-2026-0026',
    cliente: 'Inmobiliaria Sierra Madre, S.A. de C.V.',
    clienteContacto: 'Lic. Karla Elizondo · 81 1234 5567',
    materia: 'Civil',
    tipoAsunto: 'Nulidad de contrato',
    autoridad: 'Tribunal Superior de Justicia de N.L., Sala Civil',
    numeroJudicial: '298/2026',
    sucursalId: 'mty',
    abogadoIds: ['ab-07'],
    ubicacion: { almacen: 'Almacén Norte', pasillo: 'Pasillo 1', estante: 'Estante A', caja: 'Caja 01' },
    estado: 'Activo',
    fechaApertura: fechaRel(-118),
    etapaActual: 4,
    cuantia: '$8,300,000.00 MXN',
    resumen:
      'Nulidad de escritura de compraventa por vicios en el consentimiento del vendedor original.',
  },
  {
    id: 'ex-14',
    localizador: 'MTY-MER-2026-0067',
    cliente: 'Aceros Regiomontanos Unidos',
    clienteContacto: 'C.P. Iván Garza · 81 4407 9910',
    materia: 'Mercantil',
    tipoAsunto: 'Cobro de pagaré',
    autoridad: 'Juzgado 2° de Distrito en Nuevo León',
    numeroJudicial: '540/2026',
    sucursalId: 'mty',
    abogadoIds: ['ab-08'],
    ubicacion: { almacen: 'Almacén Norte', pasillo: 'Pasillo 1', estante: 'Estante C', caja: 'Caja 05' },
    estado: 'Activo',
    fechaApertura: fechaRel(-24),
    etapaActual: 1,
    cuantia: '$2,415,000.00 MXN',
    resumen:
      'Juicio ejecutivo mercantil por dos títulos de crédito vencidos con garantía prendaria de maquinaria.',
  },
  {
    id: 'ex-15',
    localizador: 'MTY-ADM-2026-0012',
    cliente: 'Municipio de Santa Catarina (asesoría)',
    clienteContacto: 'Lic. Hugo Peña · 81 8801 2200',
    materia: 'Administrativo',
    tipoAsunto: 'Licencias y permisos',
    autoridad: 'Tribunal Federal de Justicia Administrativa, Sala Metropolitana',
    numeroJudicial: '77/2026-19-01-2',
    sucursalId: 'mty',
    abogadoIds: ['ab-08', 'ab-07'],
    ubicacion: { almacen: 'Almacén Norte', pasillo: 'Pasillo 2', estante: 'Estante B', caja: 'Caja 10' },
    estado: 'Activo',
    fechaApertura: fechaRel(-88),
    etapaActual: 1,
    resumen:
      'Defensa de la negativa de licencia de construcción de una planta industrial en zona de reserva.',
  },
  {
    id: 'ex-16',
    localizador: 'MTY-FAM-2026-0044',
    cliente: 'Sucesión de Alberto Cantú Riojas',
    clienteContacto: 'Sra. Elsa Cantú · 81 2255 6603',
    materia: 'Familiar',
    tipoAsunto: 'Sucesión intestamentaria',
    autoridad: 'Juzgado 5° Familiar de Guadalajara',
    numeroJudicial: '1023/2026',
    sucursalId: 'mty',
    abogadoIds: ['ab-07'],
    ubicacion: { almacen: 'Almacén Norte', pasillo: 'Pasillo 2', estante: 'Estante D', caja: 'Caja 14' },
    estado: 'Activo',
    fechaApertura: fechaRel(-67),
    etapaActual: 3,
    resumen:
      'Sucesión intestamentaria con cuatro herederos y un inmueble en copropiedad pendiente de adjudicación.',
  },
]

export function expedientePorId(id: string): Expediente | undefined {
  return EXPEDIENTES.find((e) => e.id === id)
}

export function siguienteConsecutivo(sucursalClave: string, materiaClave: string): string {
  const anio = new Date().getFullYear()
  const prefijo = `${sucursalClave}-${materiaClave}-${anio}-`
  const existentes = EXPEDIENTES.filter((e) => e.localizador.startsWith(prefijo)).map((e) =>
    Number(e.localizador.split('-')[3]),
  )
  const max = existentes.length ? Math.max(...existentes) : 120
  return String(max + 1).padStart(4, '0')
}
